import { render, staticRenderFns } from "./unused_comp_Hook-ProductCard-Attrs.vue?vue&type=template&id=30e4a179&scoped=true&"
import script from "./unused_comp_Hook-ProductCard-Attrs.vue?vue&type=script&lang=js&"
export * from "./unused_comp_Hook-ProductCard-Attrs.vue?vue&type=script&lang=js&"
import style0 from "./unused_comp_Hook-ProductCard-Attrs.vue?vue&type=style&index=0&id=30e4a179&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4a179",
  null
  
)

export default component.exports